import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=4ab7854a&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"
import style0 from "./wallet.vue?vue&type=style&index=0&id=4ab7854a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7854a",
  null
  
)

export default component.exports